export default __webpack_public_path__ + "8bd0825f8e4a46317d5e693f7320cd39.jpeg";